import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class Invoices_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public Invoices: Invoices_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

